import { render, staticRenderFns } from "./acc_cart.vue?vue&type=template&id=e8b1537e&"
import script from "./acc_cart.vue?vue&type=script&lang=js&"
export * from "./acc_cart.vue?vue&type=script&lang=js&"
import style0 from "./acc_cart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports